module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "u-margin-top-30 u-margin-bottom-30"
  }, [_vm._v("\n        Future Purchases\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "for": "future_purchase",
      "label": "Are There Future Purchases?"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.futurePurchases),
      expression: "futurePurchases"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "future_purchase",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.futurePurchases = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])], 1)]), _vm._v(" "), (_vm.futurePurchases) ? _c('div', {
    staticClass: "u-margin-bottom-30"
  }, [_vm._l((_vm.purchases), function(purchase, purchaseIndex) {
    return _c('div', [_c('futurePurchase', {
      attrs: {
        "index": purchaseIndex,
        "purchase": purchase
      }
    })], 1)
  }), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addPurchase
    }
  }, [_vm._v("Add Another Future Purchase")])], 2) : _vm._e(), _vm._v(" "), (_vm.futurePurchases && _vm.purchasesTotal) ? _c('div', [_c('div', {
    staticClass: "a-table a-table--short-no-style a-table--full-width u-margin-top-30"
  }, [_c('table', {
    staticClass: "a-table--full-width",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Purchase")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Initial Purchase Date")]), _vm._v(" "), _c('th', [_vm._v("Last Purchase Date")]), _vm._v(" "), _c('th', [_vm._v("Deferment Period")]), _vm._v(" "), _c('th', [_vm._v("Age at Purchase")]), _vm._v(" "), _c('th', [_vm._v("Multiplicand")]), _vm._v(" "), _c('th', [_vm._v("Multiplier")]), _vm._v(" "), (_vm.showResaleColumn()) ? _c('th', [_vm._v("Resale Total")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Formula")]), _vm._v(" "), _c('th', [_vm._v("Total")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.purchases), function(purchase) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.jsUcfirst(purchase.description)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.jsUcfirst(purchase.type)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(purchase.purchaseDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(purchase.purchaseEnd || 'N/A'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.defermentPeriod(purchase)) + " years")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(purchase.ageAtPurchase) + " years")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(purchase.multiplicand)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(purchase.discount))]), _vm._v(" "), (_vm.showResaleColumn()) ? _c('td', [_vm._v(_vm._s(_vm.currencyFormat(purchase.resaleTotal)))]) : _vm._e(), _vm._v(" "), (purchase.resaleTotal > 0) ? _c('td', [_vm._v("\n                        (" + _vm._s(_vm.currencyFormat(purchase.multiplicand)) + " X " + _vm._s(purchase.discount) + ") - " + _vm._s(_vm.currencyFormat(purchase.resaleTotal)) + "\n                    ")]) : _c('td', [_vm._v("\n                        " + _vm._s(_vm.currencyFormat(purchase.multiplicand)) + " X " + _vm._s(purchase.discount) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(purchase.total)))])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "a-table--grey"
  }, [_c('td', {
    staticClass: "u-text-right u-bold",
    attrs: {
      "colspan": _vm.showResaleColumn() ? 10 : 9
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.currencyFormat(_vm.purchasesTotal)))])])])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d918228e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personal-injury-claims/steps/other-future-losses/FuturePurchases.vue
// module id = 1817
// module chunks = 0